import styled, { keyframes } from 'styled-components'

const transform = keyframes`
    0%,
    100% {
        border-radius: 33% 67% 70% 30% / 30% 30% 70% 70%;
}
    20% {
        border-radius: 37% 63% 51% 49% / 37% 65% 35% 63%;
}
    40% {
        border-radius: 36% 64% 64% 36% / 64% 48% 52% 36%;
}
    60% {
        border-radius: 37% 63% 51% 49% / 30% 30% 70% 70%;
}
    80% {
        border-radius: 40% 60% 42% 58% / 41% 51% 49% 59%;
}
`

const movementOne = keyframes`
    0%,
    100% {
         transform: none;
}
    50% {
        transform: translate(50%, 20%) rotateY(10deg) scale(1.2);
}
`

const movementTwo = keyframes`
    0%,
    100% {
         transform: none;
}
    50% {
        transform: translate(50%, 20%) rotate(-200deg) scale(1.2);
}
`

export const BlobCore = styled.div<{
    color?: string
    gradient?: string
    blurEffect?: boolean
}>`
    background: ${({ color }) => (color ? color : '#ed1250')};
    background-image: ${({ gradient }) => (gradient ? gradient : 'none')};
    height: 200px;
    width: 200px;
    border-radius: 30% 50% 20% 40%;
    animation: ${transform} 20s ease-in-out infinite both alternate,
        ${movementOne} 40s ease-in-out infinite both;
    opacity: 0.7;
    position: absolute;
    left: 70%;
    top: 50%;
    filter: ${({ blurEffect }) => (blurEffect ? `blur(8px)` : 'none')};
`

export const BlobTwo = styled(BlobCore)`
    background: ${({ color }) => (color ? color : '#ed1250')};
    background-image: ${({ gradient }) => (gradient ? gradient : 'none')};
    height: 500px;
    width: 500px;
    left: -200px;
    top: -150px;
    transform: rotate(-180deg);
    animation: ${transform} 30s ease-in-out infinite both alternate,
        ${movementTwo} 60s ease-in-out infinite both;
    filter: ${({ blurEffect }) => (blurEffect ? `blur(8px)` : 'none')};
`

export const BlobThree = styled(BlobCore)`
    background: ${({ color }) => (color ? color : '#ed1250')};
    background-image: ${({ gradient }) => (gradient ? gradient : 'none')};
    height: 350px;
    width: 350px;
    left: 500px;
    top: -150px;
    transform: rotate(-180deg);
    animation: ${transform} 30s ease-in-out infinite both alternate,
        ${movementTwo} 60s ease-in-out infinite both;
    filter: ${({ blurEffect }) => (blurEffect ? `blur(8px)` : 'none')};
`
